// src/pages/admin/media/Media.tsx
import React from 'react';
import AppLayout from '../../../components/layout/AppLayout';
import { Tabs } from 'antd';
import { useTranslation } from 'react-i18next';
import ImageList from './ImageList';
import SoundList from './SoundList';
import CharacterList from '../blocklyObjects/CharacterList';
import TargetList from '../blocklyObjects/TargetList';
import ObstacleList from '../blocklyObjects/Obstacle';
import SceneList from '../blocklyObjects/Scene';
import SpriteList from '../sprites/SpriteList';

const Media: React.FC = () => {
    const { t } = useTranslation();
    
    const items = [
        {
            label: t('media.images'),
            key: '1',
            children: <ImageList />,
        },
        {
            label: t('media.sounds'),
            key: '2',
            children: <SoundList />,
        },
        {
            label: t('media.character'),
            key: "3",
            children: <CharacterList />,
        },
        {
            label: t('media.target'),
            key: "4",
            children: <TargetList />,
        },
        {
            label: t('media.obstacle'),
            key: "5",
            children: <ObstacleList />,
        },
        {
            label: t('media.scene'),
            key: "6",
            children: <SceneList />,
        },
        {
            label: t('media.sprites'),
            key: '7',
            children: <SpriteList />,
        },
    ];

    return (
        <AppLayout title={t('media.title')}>
            <Tabs tabPosition="left" items={items} />
        </AppLayout>
    );
};

export default Media;
